import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FicScreenContentBase } from '@fi-shared/fic-screen/fic-screen-content-base';
import { IChatConversation, INewConversationData, IOpenConversationManageUsersData } from '@fi-shared/fi-chat/fi-chat';
import { ILightWeightUser } from '@fi-shared/models';
import { Subject } from 'rxjs';

interface FiChatConversationListScreenData {
    onOpenExistingConversation: ($event: IChatConversation) => void;
    onOpenNewConversation: (user: ILightWeightUser) => void;
    onCreateNewGroupConversation($event: INewConversationData): void;
    onOpenManageUsersConversation($event: IOpenConversationManageUsersData): void;
}

@Component({
    selector: 'fi-chat-conversation-list-screen',
    template: `
        <fic-screen>
            <fic-screen-header>
                <fic-screen-header-prefix>
                    <fic-screen-btn-close></fic-screen-btn-close>
                </fic-screen-header-prefix>
                {{ 'chat.messaging' | fiAppText }}
                <fic-screen-header-suffix>
                    <button mat-icon-button (click)="openNewConversation()">
                        <mat-icon class="fas fa-edit conversation-new-button"></mat-icon>
                    </button>
                </fic-screen-header-suffix>
            </fic-screen-header>
            <fic-screen-content (scroll)="onScroll($event)">
                <fi-chat-conversation-list
                    [updateSuggestionsList$]="updateSuggestionsList$"
                    (openExistingConversation)="onOpenExistingConversation($event)"
                    (openNewConversation)="openNewConversation($event)"
                    (createNewGroupConversation)="onCreateNewGroupConversation($event)"
                    (openManageUsersConversation)="onOpenManageUsersConversation($event)"
                >
                </fi-chat-conversation-list>
            </fic-screen-content>
        </fic-screen>
    `,
    styleUrls: ['./fi-chat-conversation-list-screen.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chat-conversation-list-screen' },
    standalone: false,
})
export class FiChatConversationListScreenComponent extends FicScreenContentBase<FiChatConversationListScreenData> {
    updateSuggestionsList$: Subject<void> = new Subject<void>();

    onScroll($event) {
        if ($event.target.offsetHeight + $event.target.scrollTop >= $event.target.scrollHeight)
            this.updateSuggestionsList$.next();
    }

    onOpenExistingConversation($event: IChatConversation) {
        this.data.onOpenExistingConversation($event);
    }

    openNewConversation(user?: ILightWeightUser) {
        this.data.onOpenNewConversation(user);
    }

    onCreateNewGroupConversation($event: INewConversationData) {
        this.data.onCreateNewGroupConversation($event);
    }

    onOpenManageUsersConversation($event: IOpenConversationManageUsersData) {
        this.data.onOpenManageUsersConversation($event);
    }
}
